/* unplugin-vue-components disabled */import { render } from "./AccordionTabs.vue?vue&type=template&id=558ae3c6&scoped=true"
import script from "./AccordionTabs.vue?vue&type=script&lang=js"
export * from "./AccordionTabs.vue?vue&type=script&lang=js"

import "./AccordionTabs.vue?vue&type=style&index=0&id=558ae3c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558ae3c6"]])

export default __exports__